<template>
  <div class="kye-report-echarts-line">
    <div class="kye-report-echarts-line_dom" ref="zxt001"></div>
    <LegendSelected
      v-if="showLegendMoreComponent"
      ref="LegendSelected"
      :legendMoreMap="legendMoreMap"
      :echartsInstance="echartsInstance"
    ></LegendSelected>
  </div>
</template>

<script>
  import * as echarts from '@kyfe/echarts5'
  import { commonProps, extend } from '../common'
  import { CHARTS_CONFIG } from '../common/basic/basic-config.js'
  import { tooltipFormatterWrap, setLegendMoreMap } from '../common/utils.js'
  import { mergeObjects } from '../../utils/merge'
  import LegendSelected from '../components/legend-selected.vue'

  export default {
    components: {
      LegendSelected
    },
    props: extend({}, commonProps),
    data() {
      return {
        echartsInstance: null,
        echartsConfig: {},
        code: '',
        legendMoreMap: {},
      }
    },
    computed: {
      showLegendMoreComponent () {
        const { visibleNum = 5, visibleNames = [] } = this.legendMoreMap || {}
        const leng = visibleNames.length ? visibleNames.length : visibleNum
        return this.showLegendMoreConfig && this.option.series.length > leng
      }
    },
    watch: {
      option: {
        deep: true,
        handler() {
          this.initEcharts()
        }
      }
    },
    mounted() {
      const { autoRender } = this.$props
      if (autoRender) {
        this.init()
      }
    },
    methods: {
      init() {
        this.initEcharts()
      },
      initEcharts() {
        const echartsInstance = echarts.init(this.$refs.zxt001)
        if (echartsInstance) {
          this.echartsInstance = echartsInstance
          const option = this.initEchartsConfig()
          this.echartsInstance.setOption(option, true)
          // 实例丢出去。自己监听自己想要的数据
          this.$emit('echartsInstanceCreated', echartsInstance)
          // 监听窗口大小变化，自动调整图表大小
          // window.addEventListener('resize', () => {
          //   echartsInstance.resize()
          // })
        }
      },
      initEchartsConfig() {
        const {
          series = [],
          xAxis = [],
          yAxis = [],
          dataZoom,
          legend,
          color = CHARTS_CONFIG.color
        } = this.$props.option || {}

        const code = this.code

        const option = {
          tooltip: {
            ...CHARTS_CONFIG.tooltip,
            ...CHARTS_CONFIG.tooltipAxisPointer.line,
            formatter: (val) => {
              const tooltipFormatterConfig = this.$props.tooltipFormatterConfig || {}
              return tooltipFormatterWrap(val, tooltipFormatterConfig, legend)
            },
          },
          legend: {
            ...CHARTS_CONFIG.legend,
          },
          grid: {
            ...CHARTS_CONFIG.grid,
          },
          xAxis: Array.from({length: xAxis.length || 1}).map(_ => {
            return {
              type: 'category',
              ...CHARTS_CONFIG.xAxis,
            }
          }),
          yAxis: Array.from({length: yAxis.length || 1}).map((ele, index) => {
            const right = index === 0
            const align = {
              ...(right ? {
                ...CHARTS_CONFIG.yAxis,
                ...CHARTS_CONFIG.yAxisAlignRight
                } : {
                  ...CHARTS_CONFIG.yAxis,
                  ...CHARTS_CONFIG.yAxisAlignLeft,
                })
            }
            return {
              type: 'value',
              ...CHARTS_CONFIG.yAxis,
              ...align,
            }
          }),
          color,
          series: Array.from({length: series.length}).map((ele, index) => {
            const colorItem = color[index]
            const LINE_CODE_MAP = {
              'zxt001': {},
              'zxt002': {
                smooth: false,
              },
              'zxt003': {
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: colorItem },
                    { offset: 1, color: 'rgba(255,255,255,0.00)' }
                  ])
                },
                lineStyle: {
                  color: colorItem,
                },
                smooth: false,
              },
              'zxt004': {
                smooth: false,
                label: {
                  show: true,
                  fontSize: 12,
                  color: '#333',
                  position: 'top'
                },
                showSymbol: true,
              }
            }
            return {
              ...CHARTS_CONFIG.seriesLineOpt,
              ...(LINE_CODE_MAP[code] || {})
            }
          }),
          dataZoom: dataZoom ? {
            ...CHARTS_CONFIG.dataZoom
          } : null,
          autoResize: true
        }
        const mergedOption = mergeObjects({...option}, {...this.$props.option})
        if (this.showLegendMoreConfig) {
          const { legendMoreMap } = setLegendMoreMap(series, mergedOption, this.$props.legendMoreMapConfig)
          this.legendMoreMap = legendMoreMap
        }
        return mergedOption
      },
    },
  }
</script>
<style lang="less" scoped>
  @width100: 100%;
  .kye-report-echarts-line {
    position: relative;
    width: @width100;
    height: @width100;
    box-sizing: border-box;
    &_dom{
      width: @width100;
      height: @width100;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/line/index.vue